<template>
    <div v-if="fetched">
        <!-- Form Example -->

        <d-list-group flush>
            <d-list-group-item class="p-3">
                <d-row>
                    <d-col>
                        <d-form>
                            <d-form-row>
                                <d-col md="3" class="form-group">
                                    <label>Typ dokumentu</label>
                                    <d-select name="type"
                                              v-model="document.type"
                                              @input="lar_errors.clear('type')"
                                              :class="{'is-invalid' : lar_errors.has('type')}"
                                              placeholder="">
                                        <option value="">--Wybierz typ</option>
                                        <option value="CEIDG">CEIDG</option>
                                        <option value="KRS">KRS</option>
                                        <option value="Dowód osobisty">Dowód osobisty</option>
                                        <option value="Inne">Inne</option>
                                    </d-select>
                                    <div class="invalid-feedback" v-text="lar_errors.get('type')"></div>
                                </d-col>
                                <d-col md="3" class="form-group">
                                    <label>Nazwa dokumentu</label>
                                    <ss-input v-model="document.name" placeholder="Nazwa dokumentu"></ss-input>
                                </d-col>
                                <d-col md="3" class="form-group">
                                    <label>Załaduj plik</label>
                                    <div class="clearboth"></div>
                                    <ss-file v-model="document.file"></ss-file>
                                    <div class="invalid-feedback" v-text="lar_errors.get('file')"></div>
                                </d-col>
                            </d-form-row>
                        </d-form>
                    </d-col>
                </d-row>
            </d-list-group-item>
        </d-list-group>
    </div>
</template>

<script>
    import LarErrors from '../../helpers/Errors';

    export default {
        name: "Document",
        components: {
            LarErrors
        },
        props: {
            props: {
                type: Object,
                default: {}
            }
        },
        data(){
            return{
                fetched: false,
                lar_errors: LarErrors,
                submitting: false,
                uid: '',
                document: {
                    id:         '',
                    name:       '',
                    client_id:  '',
                    type:       '',
                    file:       null
                },
            }
        },
        mounted(){
            this.document = this.props ? this.props : this.document;
            this.fetched = true;
            this.uid = this._uid;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.document = to;
                },
                deep: true
            }
        }
    }
</script>